// Add or remove ids here as articles are published or retired.
/*
2903	Issue 63 - Considerations for Using Cloud Services and AI within a PSO
2803	Issue 62 - Help Center Initiative - PSO Topic Submissions
2763	Issue 61 - AI Tools and Analytical Methods using Free Text Patient Safety Data
2471	Issue 60 - Comparative National Dashboard Innovations
2411	Issue 59 - Introduction to the PSOPPC Help Center
2372	Issue 58 - AI and Algorithm-related Issues in the NPSD
2371	Issue 57 - Highlights of AI in Patient Safety from the PSO Annual Meeting
2328	Issue 56 - Data Reporting Patterns in CFER-H
2287	Issue 55 - PSOPPC User Registration Goes Digital
2244	Issue 54 - Top Patient Safety Concerns
2224	Issue 53 - Common Formats Commenting Tool Introduction
2062	Issue 51 - Provider Counts in the PSO Profile
1871	Issue 50 - Common Formats for Event Reporting - Diagnostic Safety Version 1.0
1943	Issue 49 - PSOPPC Data Stewardship and Privacy Protections
1762	Issue 46 - PSO Specific Clinical Dashboards
1588	Issue 45 - Common Formats for Event Reporting - Nursing Home Version 1.0
1642	Issue 44 - RxNorm
1288	Issue 42 - PSOPPC Alternate Data Submission Enhancement
1188	Issue 40 - Recommended Practices for PSOs Assigning Pseudo Provider IDs for Data Submission to the PSOPPC
1087	Issue 39 - Common Formats for Event Reporting - Hospital Version 2.0
884		Issue 38 - Common Formats for Event Reporting - Community Pharmacy Version 1.0
764		Issue 37 - PSOPPC SFTP Security and Web Service Enhancements
744		Issue 36 - PSOPPC Alternate Data Submission
552		Issue 34 - Completing the Data Use Agreement (DUA)
361		Issue 33 - Patient Safety Event Data Minimum and Partial Reports
381		Issue 31 - The Importance of Submitting the PSO Profile
145		Issue 30 - PSOPPC Vendor Organization Account Setup Process
144		Issue 29 - Data Submission Best Practices
143		Issue 28 - The Patient Safety Organization Privacy Protection Center
142		Issue 27 - Common Formats Annotated Paper Forms and Flow Charts
141		Issue 26 - What are Common Formats
140		Issue 25 - Implementation Guide and Resources Workbook
139		Issue 24 - Information for Data Submission
138		Issue 23 - Understanding HL7 CDA
137		Issue 22 - Why Submit Patient Safety Event Data
136		Issue 21 - PSOPPC Website Passwords
135		Issue 20 - Reducing Unnecessary Hospital Readmissions The Role of the Patient Safety Organization (PSO)
134		Issue 18 - Understanding the Minimum Data Set

*/
export const PUBLISHED_ARTICLE_IDS = new Set([
	'2411',
	'2287',
	'2803',
	'2903',
	'2471',
	'2372',
	'2371',
	'2328',
	'2244',
	'2062',
	'1871',
	'1943',
	'1762',
	'1588',
	'1642',
	'1288',
	'1188',
	'1087',
	'884',	
	'764',	
	'552',	
	'361',	
	'381',	
	'145',	
	'144',	
	'143',	
	'142',	
	'141',	
	'140',	
	'139',	
	'138',	
	'137',	
	'136',	
	'135',	
	'744',	
	'134',	
	'2763',
	'2224'
]);

// Lazily resolves [groupId] -> src/Content/ArticleData/[groupId]/data.js,
// code-split per article so only the currently viewed article is loaded.
export const loadArticleData = (id) => {
  if (!PUBLISHED_ARTICLE_IDS.has(id)) {
    return Promise.resolve(null);
  }
  return import(`Content/ArticleData/${id}/data.js`)
    .then((mod) => mod[`articleContent`] ?? null);
};
